import PersonalProperties from './PersonalProperties';

export default PersonalProperties;
